import _ from 'lodash'
import { toastAlert } from './toast-alert.js'
import storage from './storage'
// import { getCart, hasCart, getTimer, isTimerRunning, refreshTimer, resumeTimer, startTimer } from './timer.js'
import { refreshTimer, timeFormatted } from './timer.js'

var cartStore = 'Shop/Orders'
var cartPath = cartStore + '.Cart'

export function getCart() {
  return storage.getPath(cartStore, cartPath)
}

export function hasCart() {
  var cart = getCart() || {}
  return !_.isEmpty(cart.items)
}


if (!window.skipGlobalTimerMessage && hasCart()) {
  var toast = null
  var message= null
  var timer = refreshTimer(timer => {
    if (window.skipGlobalTimerMessage || !hasCart()) {
      if (toast) {
        toast.close()
        toast = null
      }
      return timer
    }
    if (timer.running) {
      var remains = parseInt(timer.remaining)
      var remainsFormatted = timeFormatted(remains)
      var type = remains > 180 ? 'info' : (remains > 60 ? 'warning' : 'danger')
      message = `Your cart is waiting. Time to complete your purchase: ${remainsFormatted}.`

      if (toast) {
        toast.update({message, type})
      }
      else {
        toast = toastAlert(message, type, {

        })
      }
    } else if(toast) {
      if (!timer.timeout && !timer.running) {
        toast.close()
        toast = null
      }
      else if (timer.timeout) {
        message = `Sorry, the time allotted to hold your cart item has expired. 
          Your cart item has been removed. You need to start over.`
        toast.update({message, type: 'danger'})
      }
    }
    return timer
  })

}

